import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import {
  NuInput,
  NuMobileNumber,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import Attachement, {
  videotype,
} from "../../../../Components/Utils/CustomAttrachmentupload";
import { useFormik } from "formik";
import * as yup from "yup";
import UseEditData from "../../../../Components/Hooks/useEditData";
import { useLocation, useParams } from "react-router-dom";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import CloseIcon from "../../../../Components/Icons/Close";
import Video from "../../../../Components/Icons/Video";
import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import { CountryMIN } from "../../../../assets/CountryMini";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import MultiSelect, {
  MultiSelectSet,
} from "../../../../Components/Utils/MultiSelect";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import axiosInstance from "../../../../Services/axiosCommon";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "PDF",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function EditClient() {
  const { clientEditId } = useParams();
  const location = useLocation();
  // const cData = location.state?.data;
  const from = location.state?.from;
  const [data, setData] = useState(null);

  const { value: industry, getData: refindustry } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "industry"
  );
  const { value: designation, getData: refdesignation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "desigination"
  );

  const { value: Rating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "ratings"
  );

  const { value: status, getData: refstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "statusClient"
  );
  const { data: user } = UseDropDown(`/user/new-drop-down`);
  const [oldData, setOldData] = useState([]);
  const [search, setSearch] = useState("");
  // const [image, setImage] = useState([]);
  const [image, setImage] = useState({ preview: "", raw: "" });

  const toast = useToast();
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [fileRemoveList, setFileRemoveList] = useState([]);

  const [dataa, setDatas] = useState(data);
  const [selectedFile, setSelectedFile] = useState(null);
  const [createNew, setCreateNew] = useState([]);

  function getView() {
    axiosInstance
      .get(`/clients/${clientEditId}`)
      .then((res) => {
        console.log(res,'response');
        
        setCreateNew({
          category: res?.data?.data?.category,
          companyName: res?.data?.data?.companyName,
          industry: res?.data?.data?.industry,
          isActive: res?.data?.data?.isActive,
          address1: res?.data?.data?.address1,
          address2: res?.data?.data?.address2,
          refNumber: res?.data?.data?.refNumber,

          city: res?.data?.data?.city,
          streetName: res?.data?.data?.streetName,
          district: res?.data?.data?.district,
          state: res?.data?.data?.state,
          postalCode: res?.data?.data?.postalCode,
          country: res?.data?.data?.country,
          billingAddress1: res?.data?.data?.billingAddress1,
          removedProducts: [],
          filesToRemove: [],
          billingAddress2: res?.data?.data?.billingAddress2,
          billing_city: res?.data?.data?.billing_city,
          billing_state: res?.data?.data?.billing_state,
          billing_postal_code: res?.data?.data?.billing_postal_code,
          billing_country: res?.data?.data?.billing_country,
          shippingAddress1: res?.data?.data?.shippingAddress1,
          shippingAddress2: res?.data?.data?.shippingAddress2,
          shipping_city: res?.data?.data?.shipping_city,
          shipping_state: res?.data?.data?.shipping_state,
          shipping_postal_code: res?.data?.data?.shipping_postal_code,
          shipping_country: res?.data?.data?.shipping_country,
          designation: res?.data?.data?.designation,
          email: res?.data?.data?.email,
          phone: res?.data?.data?.phone,
          website: res?.data?.data?.website,
          crNum: res?.data?.data?.crNum,
          vatNum: res?.data?.data?.vatNum,
          salesPerson: res?.data?.data?.salesPerson,
         ratings: res?.data?.data?.ratings !== null ? String(res?.data?.data?.ratings) : null,
         pcName: res?.data?.data?.pcName,
          pcEmail: res?.data?.data?.pcEmail,

          pcDesignation: res?.data?.data?.pcDesignation,
          pcCountryCode: res?.data?.data?.pcCountryCode,
          pcMobile: res?.data?.data?.pcMobile,
          scName: res?.data?.data?.scName,
          scDesignation: res?.data?.data?.scDesignation,
          scCountryCode: res?.data?.data?.scCountryCode,
          scMobile: res?.data?.data?.scMobile,
          scEmail: res?.data?.data?.scEmail,
          status: res?.data?.data?.status,
          
          clientEmails: Array.isArray(res?.data?.data?.clientEmails) ? res?.data?.data?.clientEmails : [],

          countryCode: res?.data?.data?.phoneCC,

          image: res?.data?.data?.image?.file,
          oldImage: res?.data?.data?.image?.file,

          rfqAssigneeNames: [],
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
  useEffect(() => {
    // if (!cData) {
    getView();
    console.log(createNew,"createnew");
    
    // }
  }, []);

  const handleUserSelect = (selectedOptions) => {
    setSelectedUsers(selectedOptions);
  };
  const [error, setError] = useState("");
  const [items, setItems] = useState([]);
  const [remove, setRemove] = useState([]);
  const [combinedItems, setCombinedItems] = useState([]);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");

  const { Oncancel, editFormData, contextHolder, isLoading } =
    useEditFormData();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      companyName: yup.string().required("Company Name is required!"),
      // email: yup.string()
      // .email("Invalid email format")
      // .required("Email is required!"),
      // phone: yup
      //   .string()
      //   .matches(/^\d+$/, "Phone number must contain only digits")
      //   .min(8, "Phone number must be at least 8 digits")
      //   .max(11, "Phone number must be at most 11 digits")
      //   .required("Phone number is required"),
      // pcDesignation: yup
      //   .string()
      //   .required("Primary Contact Designation is required!"),
      // pcName: yup.string().required("Primary Contact Person Name is required!"),
      // pcMobile: yup
      //   .string()
      //   .matches(/^\d+$/, "Phone number must contain only digits")
      //   .min(8, "Phone number must be at least 8 digits")
      //   .max(11, "Phone number must be at most 11 digits")
      //   .required("Phone number is required"),

      // pcEmail: yup
      //   .string()
      //   .email("Invalid email format")
      //   .required("Email is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true);
      // if (items.length === 0 && data?.productList?.length === 0) {
      //   setError("Product table is empty");
      //   return;
      // }
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        // productList: combinedItems,
        // removedProducts: remove,
        filesToRemove: fileRemoveList,
      };

      formData.append("json_data", JSON.stringify(valueWithItems));
      formData.append("clientLogo", image.raw);

      // if (selectedFile !== null) {
      //   selectedFile.forEach((file) => {
      //     formData.append("attachments", file);
      //   });
      // } else {
      //   formData.append("attachments", []);
      // }
       await editFormData({url:`/clients/edit_client/${clientEditId}`,formData:formData,navigateUrl:from ||`/client-management/clients`,resetForm:resetForm
        
      }) 

    //  await editFormData(
    //     `/clients/edit_client/${clientEditId}`,
    //     formData,
    //     resetForm,
    //     from
    //   );
      // setLoading(false)
    },
  });

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        // let fileExtention = fileName.split(".").reverse()[0];
        // if (filetype?.includes(fileExtention)) {
        tempArr.push(fileName);
        // } else {
        //   let x = URL.createObjectURL(item);
        //   tempArr.push(x);
        // }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      // console.log(data.attachments, "ghjkllgd");
      setFilePathList(data?.attachments);

      setRemoveFilePathList(data?.attachments);
    }
  }, [data]);

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }
  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };

  const [inputKey, setInputKey] = useState(Date.now()); 
  

  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const handleImageRemove = () => {
    setImage({
      preview: "",
      raw: "",
    });
    setCreateNew((prevState) => ({ ...createNew, clientLogo: "" }));
    formik.values.image = "";
    formik.values.oldImage = "";

    setInputKey(Date.now()); 
  };

  const [useShipAddress, setShipAddress] = useState(false);
  function handleShipAddress(e) {
    setShipAddress(e.target.checked);
    if (e.target.checked) {
      formik.values.shippingAddress1 = formik.values.billingAddress1;
      formik.values.shippingAddress2 = formik.values.billingAddress2;
      formik.values.shipping_country = formik.values.billing_country;
      formik.values.shipping_city = formik.values.billing_city;
      formik.values.shipping_state = formik.values.billing_state;
      formik.values.shipping_postal_code = formik.values.billing_postal_code;
    } else {
      formik.values.shippingAddress1 = "";
      formik.values.shippingAddress2 = "";
      formik.values.shipping_country = "";
      formik.values.shipping_city = "";
      formik.values.shipping_state = "";
      formik.values.shipping_postal_code = "";
    }
  }

  const [address, setAddress] = useState(false);
  function handleAddress(e) {
    setAddress(e.target.checked);
    if (e.target.checked) {
      formik.values.billingAddress1 = formik.values.address1;
      formik.values.billingAddress2 = formik.values.address2;
      formik.values.billing_country = formik.values.country;
      formik.values.billing_city = formik.values.city;
      formik.values.billing_state = formik.values.state;
      formik.values.billing_postal_code = formik.values.postalCode;
    } else {
      formik.values.billingAddress1 = "";
      formik.values.billingAddress2 = "";
      formik.values.billing_country = "";
      formik.values.billing_city = "";
      formik.values.billing_state = "";
      formik.values.billing_postal_code = "";
    }
  }

  const [billAddress, setBillAddress] = useState(false);
  function handleBillAddress(e) {
    setBillAddress(e.target.checked);
    if (e.target.checked) {
      formik.values.shippingAddress1 = formik.values.address1;
      formik.values.shippingAddress2 = formik.values.address2;
      formik.values.shipping_country = formik.values.country;
      formik.values.shipping_city = formik.values.city;
      formik.values.shipping_state = formik.values.state;
      formik.values.shipping_postal_code = formik.values.postalCode;
    } else {
      formik.values.shippingAddress1 = "";
      formik.values.shippingAddress2 = "";
      formik.values.shipping_country = "";
      formik.values.shipping_city = "";
      formik.values.shipping_state = "";
      formik.values.shipping_postal_code = "";
    }
  }
  const [clientEmailsInput, setclientEmailsInput] = useState("");
 const addclientEmails = () => {
    if (clientEmailsInput.trim()) {
      const newclientEmails = [...formik.values.clientEmails, clientEmailsInput.trim()];
      formik.setFieldValue("clientEmails", newclientEmails);
      setclientEmailsInput("");
    }
  };

  const removeclientEmails = (index) => {
    const newclientEmails = formik.values.clientEmails.filter((_, i) => i !== index);
    formik.setFieldValue("clientEmails", newclientEmails);
  };
  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-between mb-4">
        <Breadcrumb
          items={[
            // { name: "Client-Management" },
            {
              name: "Client",
              link: "/client-management/clients",
            },

            { name: "Edit" },
          ]}
        />
        <BackButton />
      </div>

      <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto  rounded-md  mt-4">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto p-4 bg-white rounded-md ">
            <div className="w-full h-full flex justify-start content-start flex-wrap   mb-4">
              <div className="w-full">
         
                                           <SettingHeading title={`Client : ${createNew?.refNumber}` } />
                  
              </div>
              <CustomImgUpload
               key={inputKey}
                borderStyle="dashed"
                isRemove={true}
                width="w-full md:w-1/2"
                removeFunction={handleImageRemove}
                handleChange={handleChangeImg}
                preview={image.preview || createNew.image || ""}
              />
              <NuInput
                label="Company"
                type="text"
                formik={formik}
                placeholder="Company"
                name="companyName"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-2/3"
              />

              <FormikSelectTwo
                type="text"
                label="Industry"
                placeholder="Industry"
                Options={industry}
                formik={formik}
                name="industry"
                width="w-full md:w-1/2 lg:w-1/3"
                displayProperty={"Industry"}
                propertyName={"industry"}
                getFunc={refindustry}
              />

              <NuInput
                type="email"
                label="Email"
                placeholder="Email"
                formik={formik}
                name="email"
                // isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuMobileNumber
                nunCode="countryCode"
                label="Phone"
                placeholder="Phone"
                formik={formik}
                name="phone"
                // isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={true}
                PortalTarget={false}
              />
              <NuInput
                label="Website"
                type="text"
                formik={formik}
                placeholder="Website"
                name="website"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="CR Number"
                placeholder="CR Number"
                formik={formik}
                // Options={Invoice}
                name="crNum"
                // isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
                // disabled={true}
              />
              <NuInput
                type="text"
                label="VAT Number"
                placeholder="VAT Number"
                formik={formik}
                // Options={Invoice}
                name="vatNum"
                // isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
                // disabled={true}
              />
              <FormikSelectTwo
                type="text"
                Options={user}
                label="Sales Preson"
                placeholder="Choose"
                // value={selectedUsers}
                // onChange={handleUserSelect}
                formik={formik}
                name="salesPerson"
                width="w-full md:w-1/2 lg:w-1/3"
              />
             <FormikSelectTwo
                Options={Rating}
                label=" Ratings"
                placeholder=" Ratings"
                formik={formik}
                name="ratings"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                label="Status"
                placeholder="Choose"
                Options={status}
                formik={formik}
                name="status"
                width="w-full md:w-1/3 md:-mt-1 "
                getFunc={refstatus}
                displayProperty={"Status"}
                propertyName={"statusClient"}
                FixPosition={true}
                PortalTarget={false}
              />

              {/* <NuMobileNumber
              nunCode="country_code"
              label="Primary Contact"
              placeholder="Primary Contact"
              // formik={formik}
              name="mobileNo"
              // isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            /> */}

              {/* <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>
              <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {data?.attachments &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                            onClick={() => UpdateAttachmentList(imgs?.file)}
                          >
                            <CloseIcon color="white" height="8" width="8" />
                          </div>
                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "PDF" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                  <Attachement
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                  />
                </div>
              </div> */}
            </div>
          </div>

          <div className="sm:flex gap-2">
            <div className="sm:w-[50%] mx-auto p-4 bg-white rounded-md mt-4 ">
              <div className=" w-full h-full flex justify-start content-start flex-wrap mb-4">
                <div className="w-full">
                                            <SettingHeading title="Primary Contact"  />
                  
                </div>
                <NuInput
                  type="text"
                  label="Contact Person "
                  placeholder="Contact Person "
                  formik={formik}
                  name="pcName"
                  // isRequired={true}
                  width="w-full md:w-1/2 lg:w-1/2"
                />

                <FormikSelectTwo
                  type="text"
                  label="Designation"
                  placeholder="Designation"
                  Options={designation}
                  formik={formik}
                  name="pcDesignation"
                  width="w-full md:w-1/2 lg:w-1/2"
                  // isRequired={true}
                />

                <NuMobileNumber
                  nunCode="pcCountryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="pcMobile"
                  // isRequired={true}
                  width="w-full md:w-1/2 lg:w-1/2"
                  FixPosition={true}
                  PortalTarget={false}
                />

                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="pcEmail"
                  // isRequired={true}
                  width="w-full md:w-1/2 lg:w-1/2"
                />
              </div>
              {/* <div className=" px-4 pb-2 flex gap-1">
                          <input
                            type="checkbox"
                            checked={useAddress}
                            onChange={handleAddress}
                          />
                          <label className=" text-xs">
                            Use Billing Address as Shipping Address
                          </label>
                        </div> */}
            </div>

            <div className="sm:w-[50%] mx-auto p-4 bg-white rounded-md mt-4 ">
              <div className=" w-full h-full flex justify-start content-start flex-wrap mb-4">
                <div className="w-full">
                                                              <SettingHeading title="Secondary Contact "  />

                </div>

                <NuInput
                  type="text"
                  label="Contact Person "
                  placeholder="Contact Person "
                  formik={formik}
                  name="scName"
                  width="w-full md:w-1/2 lg:w-1/2"
                />

                <FormikSelectTwo
                  type="text"
                  label="Designation"
                  placeholder="Designation"
                  Options={designation}
                  formik={formik}
                  name="scDesignation"
                  width="w-full md:w-1/2 lg:w-1/2"
                />

                <NuMobileNumber
                  nunCode="scCountryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="scMobile"
                  width="w-full md:w-1/2 lg:w-1/2"
                  FixPosition={true}
                  PortalTarget={false}
                />

                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="scEmail"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
              </div>
            </div>
          </div>

          <div className="w-full mx-auto  bg-white rounded-md  mt-4 p-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
              <div className="w-full">
                                                            <SettingHeading title="Address "  />

              </div>

              <NuInput
                type="text"
                label=" Address Line 1"
                placeholder="Address Line 1"
                formik={formik}
                name="address1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label=" Address Line 2"
                placeholder="Address Line 2"
                formik={formik}
                name="address2"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="city"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="Street Name"
                placeholder="Street Name"
                formik={formik}
                name="streetName"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="District"
                placeholder="District"
                formik={formik}
                name="district"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="postalCode"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={true}
                PortalTarget={false}
              />
            </div>
          </div>

          <div className="w-full mx-auto  bg-white rounded-md  mt-4 p-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
              <div className="w-full sm:flex">
              <div className='flex'>
                                                       <SettingHeading title="Billing Address"  />
              
                            </div>

                <div className=" pb-2 pt-4 px-4 flex gap-1">
                  <input
                    type="checkbox"
                    checked={address}
                    onChange={handleAddress}
                  />
                  <label className=" text-xs py-0.5">Same as Address</label>
                </div>
              </div>

              <NuInput
                type="text"
                label="Street Address Line 1"
                placeholder="Street Address Line 1"
                formik={formik}
                name="billingAddress1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="Street Address Line 2"
                placeholder="Street Address Line 2"
                formik={formik}
                name="billingAddress2"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="billing_city"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="billing_state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="billing_postal_code"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="billing_country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={true}
                PortalTarget={false}
              />
            </div>
          </div>

          <div className="w-full mx-auto  bg-white rounded-md  mt-4 p-4  ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap ">
              <div className="w-full sm:flex">
               <div className='flex'>
                                                        <SettingHeading title="Shipping Address"  />
              </div>

                <div className=" pb-2 pt-4 px-4 flex gap-1">
                  <input
                    type="checkbox"
                    checked={billAddress}
                    onChange={handleBillAddress}
                  />
                  <label className=" text-xs py-0.5">Same as Address</label>
                </div>
                <div className=" pb-2 pt-4 px-4 flex gap-1">
                  <input
                    type="checkbox"
                    checked={useShipAddress}
                    onChange={handleShipAddress}
                  />
                  <label className=" text-xs py-0.5">
                    Same as Billing Address
                  </label>
                </div>
              </div>

              <NuInput
                type="text"
                label="Street Address Line 1"
                placeholder="Street Address Line 1"
                formik={formik}
                name="shippingAddress1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="Street Address Line 2"
                placeholder="Street Address Line 2"
                formik={formik}
                name="shippingAddress2"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="shipping_city"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="shipping_state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="shipping_postal_code"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="shipping_country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={true}
                PortalTarget={false}
              />

              {/* <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-1/2 "
                new_width="w-full lg:w-2/3"
              /> */}

              {/* <div className="w-full  mx-auto my-4 mt-8 ">
                <div className="flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div> */}
              </div>
              </div>
               <div className="w-full mx-auto  bg-white rounded-md  mt-4 p-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
            <div className="w-[40%]">
 <SettingHeading title="Additional Emails" />
                      <div className="flex items-center space-x-2 mb-3">
                        <NuInput
                          type="text"
                          placeholder="Enter clientEmails"
                          value={clientEmailsInput}
                          onChange={(e) => setclientEmailsInput(e.target.value)}
                          width="w-full"
                        />
                        <button
                          type="button"
                          onClick={addclientEmails}
                          className="bg-baseColor-primary text-white px-2 py-1 rounded-md shadow hover:bg-blue-600 transition"
                        >
                          +
                        </button>
                      </div>
                      <div className="border rounded-lg p-3 space-y-2 w-full bg-white h-48 overflow-y-auto">
                        {formik.values?.clientEmails?.length === 0 && (
                          <p className="text-sm text-gray-400 italic">No Client Email added.</p>
                        )}
                        {formik.values?.clientEmails?.map((clientEmails, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between border rounded-md px-2 py-1  "
                          >
                            <span className="text-gray-800 text-xs">{clientEmails}</span>
                            <button
                              type="button"
                              onClick={() => removeclientEmails(index)}
                              className="text-red-500 hover:text-red-700 text-lg font-semibold"
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
            </div>

              <div className="w-full mx-auto my-4 mt-8 pb-2">
                <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditClient;
